export default "<g><path d=\"M12 10a2 2 0 110 4 2 2 0 010-4zm6 0a2 2 0 110 4 2 2 0 010-4zM6 10a2 2 0 110 4 2 2 0 010-4z\" fill-rule=\"evenodd\"/></g>\n";